import React from 'react';
import ReactTooltip from 'react-tooltip';
import './Tooltip.css';
/**
 * Simple tooltip using react-tooltip 3rd party component. If no text property is passed in, the tooltip will
 * not render.
 *
 * You can add <br /> in the "text" property to breakup long tooltips
 */
const Tooltip = (props) => {
    const toolTipId = `tooltip-${props.name}`;
    return props.text ? (React.createElement(React.Fragment, null,
        React.createElement(ReactTooltip, { id: toolTipId, type: "dark", effect: "solid", multiline: true }),
        React.createElement("span", { "data-tip": props.text, "data-for": toolTipId, className: props.className || 'fas fa-question-circle tooltip-color' }))) : null;
};
export default Tooltip;
